import store from 'store';

const Keys = {
  KEY_SHOULD_SAVE_VEHICLE: 'shouldSaveVehicle',
  HIDE_PAY_CARD_SHIP_STATUS: 'hidePayCardShipStatus',
  NEXT_HOME_SCREEN_CARD_INTERVAL: 'nextHomeScreenCardInterval',
  SHOWN_HOME_SCREEN_CARDS: 'shownHomeScreenCards',
};

const Values = {
  VALUE_Y: 'Y',
};

const settings = {
  get shouldSaveVehicle() {
    const storedValue = store.get(Keys.KEY_SHOULD_SAVE_VEHICLE);
    return storedValue === Values.VALUE_Y;
  },

  set shouldSaveVehicle(shouldSave) {
    if (shouldSave) {
      store.set(Keys.KEY_SHOULD_SAVE_VEHICLE, Values.VALUE_Y);
    } else {
      store.remove(Keys.KEY_SHOULD_SAVE_VEHICLE);
    }
  },

  get hidePayCardShipStatus() {
    const storedValue = store.get(Keys.HIDE_PAY_CARD_SHIP_STATUS);
    return storedValue === Values.VALUE_Y;
  },

  set hidePayCardShipStatus(shouldSave) {
    if (shouldSave) {
      store.set(Keys.HIDE_PAY_CARD_SHIP_STATUS, Values.VALUE_Y);
    } else {
      store.remove(Keys.HIDE_PAY_CARD_SHIP_STATUS);
    }
  },

  get nextHomeScreenCardInterval() {
    return store.get(Keys.NEXT_HOME_SCREEN_CARD_INTERVAL);
  },

  set nextHomeScreenCardInterval(nextInterval) {
    store.set(Keys.NEXT_HOME_SCREEN_CARD_INTERVAL, nextInterval);
  },

  get shownHomeScreenCards() {
    const cards = store.get(Keys.SHOWN_HOME_SCREEN_CARDS);
    return cards ? JSON.parse(cards) : [];
  },

  set shownHomeScreenCards(cards) {
    store.set(Keys.SHOWN_HOME_SCREEN_CARDS, cards);
  },
};

export default settings;
